import { createNavigation } from "next-intl/navigation"
import { defineRouting } from "next-intl/routing"

// Can be imported from a shared config
export const locales = ["he", "en", "ar", "ru"] as const

export const routing = defineRouting({
  locales: locales,

  // If this locale is matched, pathnames work without a prefix (e.g. `/about`)
  defaultLocale: "he",
  localeDetection: false,
  localePrefix: "as-needed",
  alternateLinks: false,
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing)
